<template>
  <div>
    <!-- <v-row fill-height align="center" justify="center" style="margin:0">
      <span v-if="units.count == 0">Tidak Ada Data</span>
    </v-row> -->
    <v-tabs color="primary accent-4" class="mt-5">
      <v-tab v-for="(tab, index) in tabOptions" :key="index">{{
        tab.label
      }}</v-tab>

      <v-tab-item v-for="(tab, index) in tabOptions" :key="index">
        <v-container fluid>
          <v-row>
            <v-col
              v-for="item in filteredUnits(tab.id_type_banner)"
              :key="item.id"
              cols="12"
              md="4"
            >
              <v-card elevation="7" class="mx-auto">
                <v-img :src="$url_img + item.foto_web" height="154" class="">
                  <v-card-actions class="d-flex justify-end ">
                    <v-btn
                      depressed
                      v-if="!item.is_hidden"
                      fab
                      x-small
                      dark
                      @click="(item.is_hidden = true), viewUpdate(item)"
                      color="blue"
                    >
                      <v-icon>mdi-eye</v-icon>
                    </v-btn>
                    <v-btn
                      depressed
                      v-else
                      fab
                      x-small
                      dark
                      @click="(item.is_hidden = false), viewUpdate(item)"
                      color="red"
                    >
                      <v-icon>mdi-eye-off</v-icon>
                    </v-btn>

                    <v-spacer></v-spacer>

                    <v-btn
                      fab
                      small
                      dark
                      color="teal"
                      @click="onDetail(item.id)"
                    >
                      <v-icon dark>mdi-grease-pencil</v-icon>
                    </v-btn>
                    <v-btn
                      fab
                      small
                      dark
                      color="pink"
                      @click="onDelete(item.id)"
                    >
                      <v-icon dark>mdi-delete</v-icon>
                    </v-btn>
                  </v-card-actions>
                </v-img>
                <v-list-item>
                  <v-list-item-content>
                    <div class="d-flex justify-space-between ">
                      <div>
                        <v-list-item-subtitle
                          >Nama : {{ item.nama }}</v-list-item-subtitle
                        >
                        <v-list-item-subtitle
                          >Deskripsi :
                          {{
                            item.deskripsi.length > 20
                              ? item.deskripsi.substring(0, 20) + '..'
                              : item.deskripsi
                          }}</v-list-item-subtitle
                        >
                      </div>
                      <v-btn
                        @click="$router.push('/preview/' + item.id)"
                        x-small
                        color="green"
                        class="white--text"
                        ><v-icon small>mdi-eye</v-icon>Preview</v-btn
                      >
                    </div>
                  </v-list-item-content>
                </v-list-item>
              </v-card>
            </v-col>
          </v-row>
        </v-container>
      </v-tab-item>
    </v-tabs>
  </div>
</template>

<script>
import moment from 'moment';
export default {
  name: 'Banner',
  props: {
    units: { Array },
    onDetail: Function,
    onDelete: Function,
    viewUpdate: Function
  },
  data() {
    return {
      tabOptions: [
        { id_type_banner: 1, label: 'Umum' },
        { id_type_banner: 5, label: 'Lelang' }
        
      ]
    };
  },
  filters: {
    countDoc(doc) {
      if (doc !== null) {
        return true;
      }
    },
    datediff: date => {
      return moment(date).from();
    },
    dateFormat: date => {
      return moment.utc(date).format('DD MMM YYYY');
    },
    timeFormat: date => {
      return moment.utc(date).format('HH:mm');
    },
    dateTimeFormat: date => {
      return moment.utc(date).format('DD MMM YYYY HH:mm');
    }
  },
  methods: {
    filteredUnits(idTypeBanner) {
      if (this.units) {
        return this.units.filter(unit => unit.id_type_banner === idTypeBanner);
      }
    }
  }
};
</script>
